import React from 'react';
import Globalize from 'globalize';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../public/css/barri.css';
import BfgNavBar from './navBar.js';
import BfgFooter from './footer.js';
import ReactGA from 'react-ga';
import { browserHistory } from 'react-router';

// require('../public/css/barri.css')

var connect = require('react-redux').connect;

Globalize.load(
  require("cldr-data/main/en/ca-gregorian.json"),
  require('cldr-data/main/en/timeZoneNames.json'),
  require('cldr-data/main/en/numbers.json'),
  require('cldr-data/main/en/currencies.json'),
  require('cldr-data/main/es/ca-gregorian.json'),
  require('cldr-data/main/es/timeZoneNames.json'),
  require('cldr-data/main/es/numbers.json'),
  require('cldr-data/main/es/currencies.json'),
  require('cldr-data/supplemental/currencyData.json'),
  require('cldr-data/supplemental/plurals.json'),
  require('cldr-data/supplemental/likelySubtags.json'),
  require('cldr-data/supplemental/timeData.json'),
  require('cldr-data/supplemental/weekData.json')
);
Globalize.locale("es");
Globalize.loadMessages(require('../files/en.json'));

function logPageView() {
  //console.log("Loggin pageview");

  if (typeof window !== 'undefined') {

    ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
    //console.log("Logged OK", { page: window.location.pathname + window.location.search });
  } else {
    //console.log("Windows undefined");
  }
}

class AppComponent extends React.Component {

  constructor(props) {

    super(props);

    let lang = 'es';
    if (typeof window !== 'undefined' && window.location.pathname == '/careers.aspx') {
      lang = 'en';
    }

    this.state = { locale: this.props.params.locale || lang };

    this.handleLocaleChange = this.handleLocaleChange.bind(this);

  }

  handleLocaleChange(language, fromUrl) {

    this.setState({
      locale: language
    });
    this.changeLocaleFromServer(language, fromUrl);
  }

  changeLocaleFromServer(language, fromUrl) {
    $.ajax({
      url: '/api/localeApp',
      type: 'POST',
      dataType: 'json',
      data: { idLocale: language },
      cache: false,
      success: function (data) {
        // this.setState({ locale: data });
        this.props.setLanguage(data.locale);
        if (fromUrl)
          this.removeQuery("loc")
      }.bind(this),
      error: function (xhr, status, err) {
        console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  }

  removeQuery(...queryNames) {
    const location = this.props.location;
    queryNames.forEach(q => {
      delete location.query[q]
    }
    );
    browserHistory.push(location);
  }

  componentDidMount() {
    ReactGA.initialize('UA-98389131-1');

    let queryParams = this.props.location && this.props.location.query;
    if (queryParams.loc && (queryParams.loc == "es" || queryParams.loc == "en") && queryParams.loc != this.props.locale) {
      this.handleLocaleChange(queryParams.loc, true);
    }else if(queryParams.loc == this.props.locale){
      this.removeQuery("loc");
    }
  }

  render() {

    return (
      <div className="wrapper">
        <div className="header-v8 header-sticky">
          <BfgNavBar onLocalChange={this.handleLocaleChange} locale={this.props.locale}
            history={this.props.history} />
        </div>
        {React.cloneElement(this.props.children, { locale: this.props.locale, logPageView: logPageView, handleLocaleChange: this.handleLocaleChange })}
        <footer id="bfgFooter"><BfgFooter locale={this.props.locale} history={this.props.history} /></footer>
      </div>
    );
  }
}

const AppComponentState = function (state) {
  var stateJSON = JSON.stringify(state).replace(/<\/script/g, '<\\/script').replace(/<!--/g, '<\\!--');
  return {
    initialState: "window.__INITIAL_STATE__ = " + stateJSON,
    locale: state.locale
  }
}

const AppCmpDispatch = (dispatch) => {
  return {
    setLanguage: function (lang) {
      dispatch({
        type: 'set_language',
        lang: lang
      })
    }
  }
}

AppComponent = connect(
  AppComponentState,
  AppCmpDispatch
)(AppComponent)

module.exports = AppComponent


// WEBPACK FOOTER //
// ./js/app.js